import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-active",
  "use": "icon-icon-active-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol viewBox=\"0 0 10 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-active\">\n<path id=\"icon-icon-active_Union\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H10V10H0V0ZM1.66667 1.66667H8.33333V8.33333H1.66667V1.66667ZM6.66667 3.33333H3.33333V6.66667H6.66667V3.33333Z\" fill=\"#19E3FF\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol